<template>
	<div class="content-wrapper claim-form-wrapper claim-detail" tabindex="0">
		<div class="load-spinner" v-if="loading">
			<vue-simple-spinner size="large" message="Loading..." line-fg-color="#00355f"></vue-simple-spinner>
		</div>
		<!--<span v-on:click="closeModal()" v-on:keyup.enter="closeModal()" class="icon icon-close modal-close" tabindex="0"></span>-->
		<div class="container-fluid">
			
			<h2 class="claim-form-heading">Claim Details</h2>


			<div class="claim-form">
                <div class="claim-form-body">
                    <!--Base Claim Info-->
                    <div class="form-row" v-if="claimType">
                        <span class="form-label">Claim Type:</span>
                        <span class="form-value">{{claimType}}</span>
                    </div>
                    <div class="form-row" v-if="submitDate">
                        <span class="form-label">Date Submitted:</span>
                        <span class="form-value">{{formatDate(submitDate)}}</span>
                    </div>
                    <div class="form-row">
                        <span class="form-label">Claim Status:</span>
                        <span v-if="isProcessed" class="form-value processed">Processed</span>
                        <span v-if="!isProcessed" class="form-value unprocessed">Not Processed</span>
                    </div>
                    <div class="form-row" v-if="dealerLocation">
                        <span class="form-label">Dealer:</span>
                        <span class="form-value">
                            <span v-html="dealerLocation.CompanyName" v-if="dealerLocation.CompanyName"/>
                            <br />
                            <span v-if="dealerLocation.MailingAddress">
                                {{dealerLocation.MailingAddress}}<br />
                            </span>
                            <span v-if="dealerLocation.Street2">
                                {{dealerLocation.Street2}}<br />
                            </span>
                            <span v-if="dealerLocation.MailingCity">{{dealerLocation.MailingCity}},</span> {{dealerLocation.MailingState}} {{dealerLocation.MailingZip}}
                        </span>
                    </div>

                    <div class="form-row" v-if="invoiceNo">
                        <span class="form-label">Invoice #:</span>
                        <span class="form-value">{{invoiceNo}}</span>
                    </div>
                    <div class="form-row" v-if="invoiceDate">
                        <span class="form-label">LMC Invoice Date:</span>
                        <span class="form-value">{{formatDate(invoiceDate)}}</span>
                    </div>


                    <!--Claim Type IDs
    ==============
    Authorization to Deduct: 6
    Claim and Adjustment: 1
    Incorrect Dealer: 0
    Duplicate Billing: 3
    Incorrect Service Fee: 5(?)
    Incorrect Due Date: 6-->

                    <!--If it is an Incorrect Due Date OR Incorrect Service Fee, display current due date-->
                    <div class="form-row" v-if="claimAmount">
                        <span class="form-label">Amount Requested:</span>
                        <span class="form-value">${{formatPrice(claimAmount)}}</span>
                    </div>

                    <!--If it is an Incorrect Due Date OR Incorrect Service Fee OR Claim & Adjustment, display current due date-->
                    <div v-if="currentDueDate" class="form-row">
                        <span class="form-label">Current Due Date:</span>
                        <span class="form-value">{{formatDate(currentDueDate)}}</span>
                    </div>

                    <div class="form-row" v-if="supplierName">
                        <span class="form-label">Supplier:</span>
                        <span v-html="supplierName" class="form-value"></span>
                    </div>
                    <div class="form-row" v-if="supplierInvoiceNo">
                        <span class="form-label">Supplier Invoice #:</span>
                        <span class="form-value">{{supplierInvoiceNo}}</span>
                    </div>
                    <div class="form-row" v-if="supplierInvoiceDate">
                        <span class="form-label">Supplier Invoice Date:</span>
                        <span class="form-value">{{formatDate(supplierInvoiceDate)}}</span>
                    </div>

                    <!--If it is an Authorization to Deduct, display who quoted price-->
                    <div v-if="quotedBy" class="form-row">
                        <span class="form-label">Who Quoted Price:</span>
                        <span class="form-value">{{quotedBy}}</span>
                    </div>


                    <!--If it is not a Duplicate Billing, display Reason for Request-->
                    <div v-if="claimReason" class="form-row">
                        <span class="form-label">Reason for Request:</span>
                        <span v-html="claimReason" class="form-value"></span>
                    </div>


                    <!--Base Claim Contact Info-->
                    <div class="form-row" v-if="claimSubmittedBy">
                        <span class="form-label">Submitted By:</span>
                        <span class="form-value">{{claimSubmittedBy}}</span>
                    </div>
                    <div class="form-row" v-if="claimContactName">
                        <span class="form-label">Notification Contact:</span>
                        <span class="form-value">{{claimContactName}}</span>
                    </div>
                    <div class="form-row" v-if="claimContactEmail">
                        <span class="form-label">Notification Email:</span>
                        <span class="form-value">{{claimContactEmail}}</span>
                    </div>



                    <button class="modal-close close-btn" v-on:click="closeModal()">Close</button>
                    <button type="button" class="modal-print" v-on:click="print()">Print</button>
                </div>
			</div>
		</div>
	</div>


</template>

<script>
	import DateFormatService from '../../common/date-format.service';
	import ClaimsDetailService from './claims-detail.service';
	import Spinner from 'vue-simple-spinner';

	export default {
	props: {

	},
	components: {
		'vue-simple-spinner': Spinner
	},
	data: function () {
		return {
			claimAmount: 0,
			claimContactEmail: '',
			claimContactName: '',
			claimReason: '',
			claimSubmittedBy: '',
			claimType: '',
			claimTypeID: '',
			currentDueDate: '',
			dealerLocation: {},
			dealerName: '',
			invoiceDate: '',
			invoiceNo: '',
			isProcessed: false,
			loading: true,
			poNumber: '',
			quotedBy: '',
			submitDate: '',
			supplierInvoiceDate: '',
			supplierInvoiceNo: '',
			supplierName: ''
			
		}
	},
	mounted() {
		this.claimDetailID = this.claim.ClaimID;
		this.getDetails();
		$('.claim-detail').focus();
	},
	methods: {
         print: function() {
          window.print();
        },
		closeModal: function () {
			$('#claim-' + this.claimDetailID).focus();
			$('body').removeClass('dim claims-print');
			this.$close();
		},
		formatDate: function (date) {
			return DateFormatService.customFormatter(date, 'full-slash');
		},
		formatPrice: function(value) {
			let val = (value/1).toFixed(2) || 0;
			return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
		},
		getDetails() {
			ClaimsDetailService.getClaimDetails(this.claimDetailID).then(response => {
				this.claimAmount = response.DeductionAmount;
				this.claimContactName = response.ContactName;
				this.claimContactEmail = response.ContactEmail;
				this.claimReason = response.RequestReason;
				this.claimSubmittedBy = response.SubmittedByName;
				this.claimType = this.claim.ClaimType;
				this.claimTypeID = response.ClaimTypeID;
				this.currentDueDate= response.CurrentDueDate;
				this.dealerLocation = response.DealerLocation;
				this.invoiceDate = response.InvoiceDate;
				this.invoiceNo = response.InvoiceNumber;
				this.isProcessed = this.claim.IsProcessed;
				this.poNumber = response.PoNumber;
				this.quotedBy = response.QuotedPerson;
				this.submitDate = this.claim.DateClaimSubmitted;
				this.supplierInvoiceDate = response.VendorInvoiceDate;
				this.supplierInvoiceNo = response.VendorInvoiceNumber;
				this.supplierName = response.VendorName;
				

				this.loading = false;
			});
		}
	}
}

</script>